import { render, staticRenderFns } from "./CommissionAdditionalFields.vue?vue&type=template&id=79f7f7a9&scoped=true&lang=pug&"
import script from "./CommissionAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./CommissionAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionAdditionalFields.vue?vue&type=style&index=0&id=79f7f7a9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7f7a9",
  null
  
)

export default component.exports